import { useEffect, useState } from "react";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useAndamentoCienciaDocumento = () => {
  const [docCienciaParams, setDocCienciaParams] = useState({ sqAcaoFiscal: null });
  const { request: requestDocumento, data: dataDocumento } = useApiClient();

  useEffect(() => {
    if (docCienciaParams?.sqAcaoFiscal) {
      const values = docCienciaParams;
      requestDocumento(apiRoutes.fiscalizacao.ordemservico.documentoAndamentoCiencia, values);
    }
  }, [requestDocumento, docCienciaParams]);

  useEffect(() => {
    let win;
    if (dataDocumento?.result) {
      win = window.open("", "", "height=800, width=800");
      win.document.write(dataDocumento.result);
      win.document.close();
      win.setTimeout(win.print, 1000);
    }
  }, [dataDocumento]);

  const documentoPrint = () => {};

  return { documentoPrint, setDocCienciaParams };
};

export default useAndamentoCienciaDocumento;
